import { api } from "@/api";
import { useAliyunCaptcha, useTencentCaptcha } from "@/hooks";
import { query, validateEmail, validatePhone } from "@/utils";
import { useCallback, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import Storage from "store";
import { BottomText } from "../bottom";
import { Button } from "../button";
import { CaptchaCodeModal } from "../captchaCodeModal";
import { Input } from "../input";
import { Pupop } from "../pupop";
import { SelectArea } from "../selectArea";
import { Tag } from "../tag";
import { ToastContainer } from "../toast";
import { ReactComponent as EmailIcon } from "./assets/email.svg";
import { ReactComponent as EmailActiveIcon } from "./assets/emailActive.svg";
import { ReactComponent as PhoneIcon } from "./assets/phone.svg";
import { ReactComponent as PhoneActiveIcon } from "./assets/phoneActive.svg";
import "./content.scss";
import "./tags.scss";

export const Content = () => {
  // 腾讯云验证
  const {
    showCaptcha, resetCaptchaRes, captchaTicket, captchaRandStr, captchaErrorCode
  } = useTencentCaptcha();
  // 阿里云验证
  const {
    aliyunCaptchaCode, aliyunCaptchaErrorCode, triggerAliyunVerify, resetAliyunCaptchaCode
  } = useAliyunCaptcha();
  // 图文验证码弹框
  const [captchaCodeModelVisible, setCaptchaCodeModelVisible] = useState(false);
  // 是否阿里云连续验证失败
  const [isContinueAliyunError, setIsContinueAliyunError] = useState(false);
  // Toast 提示
  const toastRef = useRef();

  const navigate = useNavigate();
  const { i18n, t } = useTranslation();

  const inviteCode = query("code") || "";
  const oneThirdLength = Math.ceil(inviteCode.length / 3);
  const paramValue = inviteCode.slice(0, oneThirdLength) + "******";
  let server = query("server") || "";
  const serverThirdLength = Math.ceil(server.length / 3);
  server = server.slice(0, serverThirdLength) + "******";

  const [isPhone, setIsPhone] = useState(true);
  const [showSelectArea, setShowSelecttArea] = useState(false);
  const [areaValue, setAreaValue] = useState("+43");
  const [phone, setPhone] = useState();
  const [sendCode, setSendCode] = useState();
  const [email, setEmail] = useState("");
  const [getAreaValue, setGetAreaValue] = useState("");

  const getAreaItem = (item) => {
    setAreaValue(`+${item.prefix}`);
  };
  const getAreaValueHandler = (data) => {
    setGetAreaValue(data);
  };
  const [titlePupop, setTitlePupop] = useState("");
  const [verification, setVerification] = useState(true);
  const selectAreaHandler = (flag) => {
    setShowSelecttArea(flag);
  };
  const checkTag = (flag) => {
    setIsPhone(flag);
  };
  const [showPupop, setShowPupop] = useState(false);
  const getInputValue = (data) => {
    setPhone(data);
  };
  const getEmailValue = (data) => {
    setEmail(data);
  };
  const getCodeValue = (data) => {
    setSendCode(data);
  };
  const [pupopTitle, setPupopTitle] = useState("");
  const [loading, setLoading] = useState(false);
  const [isSend, setIsSend] = useState(false);

  const goToPage = async () => {
    const { data } = await api.post("/biz/system/getSystemConfig", {
      configKey: "downloadPageHtml", projectId: "1001"
    });
    const configValue = data.downloadPageHtml;
    window.location.href = configValue + "?language=" + i18n.language;
  };

  // 注册
  const register = async () => {
    let loginInfo, loginType, areaCode;
    if (isPhone && !phone) {
      setTitlePupop(t("手机号不能为空"));
      return;
    }
    if (!isPhone && !validateEmail(email)) {
      setTitlePupop(t("邮箱格式错误"));
      return;
    }
    if (!sendCode) {
      setTitlePupop(t("验证码不能为空"));
      return;
    }
    if (isPhone) {
      if (!areaValue) {
        setTitlePupop(t("请选择地区"));
        return;
      }
      loginInfo = phone;
      loginType = 3;
      areaCode = areaValue;
    } else {
      loginInfo = email;
      loginType = 2;
      areaCode = "";
    }
    setLoading(true);
    setTitlePupop("");
    const request = {
      loginInfo, loginType, type: 1, areaCode, inviteCode, code: sendCode, nickName: "", userPw: "", encryptKey: ""
    };
    const res = await api.post("/auth/account/register", request);
    setLoading(false);
    const resCode = res?.code;
    if (resCode == 10000) {
      setPupopTitle(t("成功"));
      setShowPupop(true);
      setTimeout(() => {
        goToPage();
      }, 1500);
    } else {
      setPupopTitle(res?.message);
      setShowPupop(true);
    }
  };

  const setShareNum = useCallback(async () => {
    await api.post(`/auth/share/${inviteCode}`);
  }, []);

  useEffect(() => {
    if (inviteCode === "") return;
    setShareNum();
  }, [inviteCode]);

  useEffect(() => {
    setIsSend(false);
  }, [isPhone]);

  // 发送验证码
  const handleSendCode = async (inputVerCode = "") => {
    setIsSend(false);
    let requestUrl = "/auth/account/v2/sendVerificationCode", requestBody;

    if (isPhone) {
      requestBody = {
        loginInfo: phone, loginType: 3, type: 1, areaCode: areaValue
      };

      if (!inputVerCode) {
        requestUrl = "/auth/account/v3/sendVerificationCode";

        if (aliyunCaptchaCode) {
          requestBody["captchaVerifyParam"] = aliyunCaptchaCode;
        } else {
          requestBody["ticket"] = captchaTicket;
          requestBody["randstr"] = captchaRandStr;
        }
      } else {
        requestBody["code"] = inputVerCode;
      }
    } else {
      requestBody = {
        loginInfo: email, loginType: 2, type: 1
      };
    }
    setTitlePupop("");
    try {
      const res = await api.post(requestUrl, requestBody, {
        timeout: 30 * 1000 // 设置超时时间
      });
      const code = res?.code;
      if (code !== 10000) {
        let errorMessage = t("发送失败");
        switch (code) {
          case 51002:
            errorMessage = "";
            // 连续失败不再进行阿里云验证
            if (isContinueAliyunError) {
              setCaptchaCodeModelVisible(true);
            } else {
              setIsContinueAliyunError(true);
              triggerAliyunVerify(false);
            }
            break;
          case 51003:
            errorMessage = t("操作失败，请重试");
            break;
          case 51004:
            errorMessage = t("操作失败，请使用真实设备");
            break;
          case 51005:
            errorMessage = t("配置错误，请联系管理员");
            break;
          case 51006:
            errorMessage = "";
            setCaptchaCodeModelVisible(true);
            break;
          case 2034:
            errorMessage = t("验证失败，请5分钟后重试");
            break;
          case 450010:
            errorMessage = t("验证码错误");
            break;
        }

        if ([450010].includes(code)) {
          return false;
        }

        if (toastRef.current && errorMessage) {
          toastRef.current.addToast(errorMessage);
        }

        return true;
      } else {
        setIsSend(true);
        return true;
      }
    } catch (error) {
      return false;
    } finally {
      // 重置腾讯云验证码返回值
      resetCaptchaRes();
      // 重置阿里云验证码返回值
      resetAliyunCaptchaCode();
    }
  };

  // 点击发送验证码前校验
  const handleClickSendCodeBtn = async () => {
    if (isPhone) {
      if (!areaValue) {
        setTitlePupop(t("请选择地区"));
        return;
      }

      if (!phone) {
        setTitlePupop(t("手机号不能为空"));
        return;
      }

      if (!validatePhone(phone)) {
        setTitlePupop(t("请输入有效手机号"));
        return;
      }

      // 验证码版本
      let captchaVersion = sessionStorage.getItem("captchaVersion");
      // 不同验证方式 2 - 图文验证 3 - 腾讯云验证码 4 - 阿里云验证码
      switch (captchaVersion) {
        case "2":
          setCaptchaCodeModelVisible(true);
          break;
        case "3":
          showCaptcha();
          break;
        case "4":
          setIsContinueAliyunError(false);
          triggerAliyunVerify();
          break;
      }
    } else {
      if (!email) {
        setTitlePupop(t("邮箱不能为空"));
        return;
      }

      if (!validateEmail(email)) {
        setTitlePupop(t("邮箱格式错误"));
        return;
      }

      // 非手机号，直接发送验证码
      handleSendCode();
    }
  };

  // 关闭验证码弹框
  const handleCancelCaptchaCodeModal = () => {
    setCaptchaCodeModelVisible(false);
    resetCaptchaRes();
    resetAliyunCaptchaCode();
  };

  // 获取验签配置
  const getSystemConfig = async () => {
    try {
      const res = await api.post("/biz/system/v2/getSystemConfig", { projectId: "" }, { timeout: 30 * 1000 });

      if (res?.code !== 10000) {
        toastRef.current?.addToast(res?.message);
      } else {
        sessionStorage.setItem("tenantCode", res?.data?.tenantCode);
        sessionStorage.setItem("captchaVersion", res?.data?.captchaVersion);
      }
    } catch (error) {
      toastRef.current?.addToast(t("获取配置失败"));
    }
  };

  // 监听腾讯无感验证码状态
  useEffect(() => {
    // 未完成验证时，不处理
    if (!captchaTicket) return;

    // 验证失败时，降级使用图文验证码
    if (captchaErrorCode) {
      setCaptchaCodeModelVisible(true);

      return;
    }

    // 验证成功，发送验证码
    handleSendCode();
  }, [captchaTicket]);

  // 监听阿里云验证码状态
  useEffect(() => {
    // 未完成验证时，不处理
    if (!aliyunCaptchaCode) return;

    // 验证失败时，降级使用图文验证码
    if (aliyunCaptchaErrorCode) {
      setCaptchaCodeModelVisible(true);

      return;
    }

    // 验证成功，发送验证码
    handleSendCode();
  }, [aliyunCaptchaCode, aliyunCaptchaErrorCode]);

  useEffect(() => {
    // 暂时解决首次进入语言不对问题
    if (Storage.get("times") === 0 || !Storage.get("times")) {
      Storage.set("times", 1);
      window.location.reload();
    }

    // 初始化拉取一次配置
    getSystemConfig();
  }, []);

  return (
    <>
      {/* Toast 弹框 */}
      <ToastContainer ref={toastRef}/>
      {/* 图文验证码弹框 type 0：登录；1：手机号注册；2：获取短信登录验证码；3：手机号找回密码 */}
      {isPhone && captchaCodeModelVisible && (<CaptchaCodeModal
        loginName={phone}
        type={1}
        cancelCallBack={handleCancelCaptchaCodeModal}
        confirmCallBack={handleSendCode}
      />)}
      {showPupop && (<Pupop setShowPupop={setShowPupop} pupopTitle={pupopTitle}/>)}
      <div className="tags">
        <Tag
          render={isPhone ? PhoneActiveIcon : PhoneIcon}
          title={t("手机号")}
          action={isPhone}
          changeClick={() => checkTag(true)}
        />
        <Tag
          render={!isPhone ? EmailActiveIcon : EmailIcon}
          title={t("邮箱")}
          action={!isPhone}
          changeClick={() => checkTag(false)}
        />
      </div>
      <div className="content-container">
        {isPhone ? (<>
          <div className="content-phone">
            <Input
              placeholder={t("地区")}
              select={true}
              selectAreaHandler={selectAreaHandler}
              isTopText={t("地区")}
              value={areaValue}
              getValue={getAreaValueHandler}
            />
            <Input
              placeholder={t("手机号")}
              isTopText={t("手机")}
              getValue={getInputValue}
            />
          </div>
          <div>
            <Input
              placeholder={t("验证码")}
              type="number"
              checkCode={handleClickSendCodeBtn}
              length={6}
              sendCode={true}
              valueText={phone}
              isSend={isSend}
              setIsSend={setIsSend}
              titleText={t("手机号不能为空")}
              setTitlePupop={setTitlePupop}
              isTopText={t("验证码")}
              getValue={getCodeValue}
              key="phone"
            />
          </div>
        </>) : (<>
          <div className="content-email">
            <Input
              placeholder={t("邮箱")}
              isTopText={t("邮箱")}
              getValue={getEmailValue}
            />
          </div>
          <div>
            <Input
              placeholder={t("验证码")}
              type="number"
              checkCode={handleClickSendCodeBtn}
              length={6}
              sendCode={true}
              isSend={isSend}
              valueText={email}
              setIsSend={setIsSend}
              setTitlePupop={setTitlePupop}
              titleText={t("邮箱格式错误")}
              isTopText={t("验证码")}
              getValue={getCodeValue}
              key="email"
            />
          </div>
        </>)}
        <div className="net-container">
          <Input
            placeholder=""
            disabled
            isTop={true}
            isTopText={t("网络地址")}
            value={server}
            titleClass={{ background: "#F0F0F0" }}
          />
        </div>
        <div>
          <Input
            placeholder=""
            value={paramValue}
            disabled
            isTop={true}
            isTopText={t("邀请码")}
            titleClass={{ background: "#F0F0F0" }}
          />
        </div>
        {showSelectArea && (<SelectArea
          setShowSelecttArea={setShowSelecttArea}
          selectAreaHandler={selectAreaHandler}
          getAreaItem={getAreaItem}
        />)}
        {verification && <div className="title">{t(titlePupop)}</div>}
        <div style={{ marginTop: "30%" }}>
          <Button
            text={t("注册")}
            loading={loading}
            disabled={loading}
            clickHandler={register}
          />
        </div>
        <div style={{ marginTop: "5%" }}>
          <Button
            text={t("已有账号")}
            loading={loading}
            className="link"
            disabled={loading}
            clickHandler={goToPage}
          />
        </div>
        <BottomText/>
      </div>
    </>
  );
};
